import React, { useState } from 'react'
import { TextInput, ContextButton, DatePicker } from '@tecuity/granite-ui'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import { format } from 'date-fns'
import CalendarIcon from '@tecuity/sos-icons/react/calendar'
import './VoidModal.scss'

const VoidModal = ({ setVoidModalOpen, voidModalOpen, label, voidMethod }) => {
  const [voidReason, setVoidReason] = useState('')
  const [voidPopupError, setVoidPopupError] = useState(false)
  const [date, setDate] = useState(format(new Date(), 'MM/dd/yyyy'))
  const [showDatePicker, setShowDatePicker] = useState(false)
  const closeVoidReasonPopup = () => {
    setVoidModalOpen(false)
  }
  return (
    <Portal isOpened={voidModalOpen}>
      <Modal
        title={`Void ${label}`}
        cancelButton
        autoHeight
        modalSize={'large'}
        closeModal={closeVoidReasonPopup}
      >
        <div className="void-popup">
          <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', marginBottom: '8px' }}>
            <TextInput
              label="Void Date"
              placeholder="MM/DD/YYYY"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
            <button
              onClick={() => setShowDatePicker(true)}
              className="btn btn-primary picker-button row-btn"
            >
              <CalendarIcon size="extra-small" />
            </button>
            <DatePicker
              label="Void Date"
              onChange={(date) => setDate(format(new Date(date), 'MM/dd/yyyy'))}
              onCalendarClose={() => setShowDatePicker(false)}
              isOpen={showDatePicker}
            />
          </div>
          <div>
            <TextInput
              label={
                <span>
                  Reason to Void {label}<span style={{ color: `hsl(345,100%,42%)` }}>*</span>
                </span>
              }
              value={voidReason}
              onChange={(e) => {
                setVoidReason(e.target.value)
              }}
              valid={voidPopupError && !voidReason ? false : undefined}
              errorMessage={voidPopupError && !voidReason ? 'Required Field' : undefined}
            />
          </div>
          <div className="save-error-message">
            <ContextButton variant="secondary" onClick={closeVoidReasonPopup}>
              Cancel
            </ContextButton>
            <ContextButton
              disabled={!voidReason}
              onClick={() => {
                if (!voidReason) {
                  setVoidPopupError(true)
                } else {
                  // call void endpoint.
                  voidMethod({
                    Reason: voidReason,
                    VoidDate: date,
                  })
                  closeVoidReasonPopup()
                }
              }}
              variant="danger"
            >
              Void
            </ContextButton>
          </div>
        </div>
      </Modal>
    </Portal>
  )
}

export default VoidModal
